import { z } from 'zod';

const envSchema = z.object({
  GATSBY_FIREBASE_API_KEY: z.string(),
  GATSBY_FIREBASE_AUTH_DOMAIN: z.string(),
  GATSBY_FIREBASE_PROJECT_ID: z.string(),
  GATSBY_FIREBASE_STORAGE_BUCKET: z.string(),
  GATSBY_FIREBASE_MESSAGING_SENDER_ID: z.coerce.number(),
  GATSBY_FIREBASE_APP_ID: z.string(),
  GATSBY_FIREBASE_MEASUREMENT_ID: z.string(),
  GATSBY_FIREBASE_FUNCTIONS_URL: z.string().url(),
  GATSBY_NODE_ENV: z.enum(['development', 'production']).default('development'),
  GATSBY_CRISP_WEBSITE_ID: z.string().uuid(),
  GATSBY_TELEMETRY_DISABLED: z.coerce.number()
});

const processEnv = {
  GATSBY_FIREBASE_API_KEY: process.env.GATSBY_FIREBASE_API_KEY,
  GATSBY_FIREBASE_AUTH_DOMAIN: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  GATSBY_FIREBASE_PROJECT_ID: process.env.GATSBY_FIREBASE_PROJECT_ID,
  GATSBY_FIREBASE_STORAGE_BUCKET: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  GATSBY_FIREBASE_MESSAGING_SENDER_ID: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  GATSBY_FIREBASE_APP_ID: process.env.GATSBY_FIREBASE_APP_ID,
  GATSBY_FIREBASE_MEASUREMENT_ID: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
  GATSBY_FIREBASE_FUNCTIONS_URL: process.env.GATSBY_FIREBASE_FUNCTIONS_URL,
  GATSBY_NODE_ENV: process.env.GATSBY_NODE_ENV,
  GATSBY_CRISP_WEBSITE_ID: process.env.GATSBY_CRISP_WEBSITE_ID,
  GATSBY_TELEMETRY_DISABLED: process.env.GATSBY_TELEMETRY_DISABLED
};

const env = envSchema.parse(processEnv);

export default env;
